export default "__VITE_ASSET__DgbPCzGQ__"